import { PropsWithChildren } from 'react';
import { useAppSelector } from '../hooks/use-app-selector';
import Menu from './layout/Menu';

type Props = PropsWithChildren<{}>;

const Layout: React.FC<Props> = ({ children }: Props): React.ReactElement => {
  const { isAuthenticated } = useAppSelector((state) => state.auth);
  return (
    <div className="App">
      {isAuthenticated && (
        <header>
          <Menu />
        </header>
      )}
      <main>{children}</main>
    </div>
  );
};

export default Layout;
